import { useState } from "react";
import { useNavigate } from "react-router-dom";
import PreRegister from "../components/preregister";
import ConfigRegister from "../components/configregister";
import "../components/loginform.css";
import { API_BASE } from "../utils/draftutils"; // <<< URL base backend

function Register() {
  const [step, setStep] = useState(1);
  const [preUsername, setPreUsername] = useState("");
  const [prePassword, setPrePassword] = useState("");
  const [newUsername, setNewUsername] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");

  const navigate = useNavigate();

  const checkPreconfig = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${API_BASE}/api/auth/pre-config`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username: preUsername, password: prePassword }),
      });

      if (res.ok) {
        setMessage("");
        setStep(2);
      } else {
        const errorText = await res.text();
        setMessage(errorText || "Credenziali preconfig non valide.");
      }
    } catch (err) {
      console.error(err);
      setMessage("Errore di connessione");
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${API_BASE}/api/auth/config-register`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username: newUsername, password: newPassword }),
      });

      if (res.ok) {
        setStep(1);
        sessionStorage.setItem("flashMessage", "Registrazione avvenuta con successo");
        navigate("/", { replace: true });
      } else {
        const errorText = await res.text();
        setMessage(errorText ? `Errore: ${errorText}` : "Registrazione non riuscita.");
      }
    } catch (err) {
      console.error(err);
      setMessage("Errore durante la registrazione");
    }
  };

  return (
    <div className="d-flex flex-column align-items-center justify-content-center vh-100 bg-configurator">
      <h2 className="fancy-title" style={{ color: "white" }}>REGISTRAZIONE CONFIGURATORE</h2>

      {step === 1 ? (
        <PreRegister
          preUsername={preUsername}
          prePassword={prePassword}
          setPreUsername={setPreUsername}
          setPrePassword={setPrePassword}
          onSubmit={checkPreconfig}
        />
      ) : (
        <ConfigRegister
          newUsername={newUsername}
          newPassword={newPassword}
          setNewUsername={setNewUsername}
          setNewPassword={setNewPassword}
          onSubmit={handleRegister}
        />
      )}

      {message && <div className="alert alert-info mt-3">{message}</div>}
    </div>
  );
}

export default Register;
